module.exports = __webpack_public_path__ + "fonts/Qs_Iranyekan.5504ec99.ttf";